/**
 * Dimension values used throughout Hawkins Professional
 */
export const Dimensions = {
    /**
     * 0px
     */
    BorderRadius0: '0px',
    /**
     * 2px
     */
    BorderRadius2: '2px',
    /**
     * 4px
     */
    BorderRadius4: '4px',
    /**
     * 6px
     */
    BorderRadius6: '6px',
    /**
     * 8px
     */
    BorderRadius8: '8px',
    /**
     * 12px
     */
    BorderRadius12: '12px',
    /**
     * 16px
     */
    BorderRadius16: '16px',
    /**
     * 100%
     */
    BorderRadius100: '100%',
    /**
     * 0px
     */
    BorderWidth0: '0px',
    /**
     * 1px
     */
    BorderWidth1: '1px',
    /**
     * 2px
     */
    BorderWidth2: '2px',
    /**
     * 4px
     */
    BorderWidth4: '4px',
    /**
     * 1919px
     */
    BreakpointLarge: '1919px',
    /**
     * 1279px
     */
    BreakpointMedium: '1279px',
    /**
     * 959px
     */
    BreakpointSmall: '959px',
    /**
     * 3840px
     */
    BreakpointXlarge: '3840px',
    /**
     * 599px
     */
    BreakpointXsmall: '599px',
    /**
     * 0
     */
    RawBorderRadius0: 0,
    /**
     * 2
     */
    RawBorderRadius2: 2,
    /**
     * 4
     */
    RawBorderRadius4: 4,
    /**
     * 6
     */
    RawBorderRadius6: 6,
    /**
     * 8
     */
    RawBorderRadius8: 8,
    /**
     * 12
     */
    RawBorderRadius12: 12,
    /**
     * 16
     */
    RawBorderRadius16: 16,
    /**
     * 0
     */
    RawBorderWidth0: 0,
    /**
     * 1
     */
    RawBorderWidth1: 1,
    /**
     * 2
     */
    RawBorderWidth2: 2,
    /**
     * 4
     */
    RawBorderWidth4: 4,
    /**
     * 1919
     */
    RawBreakpointLarge: 1919,
    /**
     * 1279
     */
    RawBreakpointMedium: 1279,
    /**
     * 959
     */
    RawBreakpointSmall: 959,
    /**
     * 3840
     */
    RawBreakpointXlarge: 3840,
    /**
     * 599
     */
    RawBreakpointXsmall: 599,
    /**
     * 8
     */
    RawSize8: 8,
    /**
     * 16
     */
    RawSize16: 16,
    /**
     * 24
     */
    RawSize24: 24,
    /**
     * 32
     */
    RawSize32: 32,
    /**
     * 36
     */
    RawSize36: 36,
    /**
     * 40
     */
    RawSize40: 40,
    /**
     * 48
     */
    RawSize48: 48,
    /**
     * 56
     */
    RawSize56: 56,
    /**
     * 112
     */
    RawSize112: 112,
    /**
     * 224
     */
    RawSize224: 224,
    /**
     * 448
     */
    RawSize448: 448,
    /**
     * 0
     */
    RawSpace0: 0,
    /**
     * 1
     */
    RawSpace1: 1,
    /**
     * 2
     */
    RawSpace2: 2,
    /**
     * 4
     */
    RawSpace4: 4,
    /**
     * 6
     */
    RawSpace6: 6,
    /**
     * 8
     */
    RawSpace8: 8,
    /**
     * 10
     */
    RawSpace10: 10,
    /**
     * 12
     */
    RawSpace12: 12,
    /**
     * 16
     */
    RawSpace16: 16,
    /**
     * 20
     */
    RawSpace20: 20,
    /**
     * 24
     */
    RawSpace24: 24,
    /**
     * 32
     */
    RawSpace32: 32,
    /**
     * 40
     */
    RawSpace40: 40,
    /**
     * 48
     */
    RawSpace48: 48,
    /**
     * 56
     */
    RawSpace56: 56,
    /**
     * 64
     */
    RawSpace64: 64,
    /**
     * 72
     */
    RawSpace72: 72,
    /**
     * 80
     */
    RawSpace80: 80,
    /**
     * 88
     */
    RawSpace88: 88,
    /**
     * 96
     */
    RawSpace96: 96,
    /**
     * 144
     */
    RawSpace144: 144,
    /**
     * 8px
     */
    Size8: '8px',
    /**
     * 16px
     */
    Size16: '16px',
    /**
     * 24px
     */
    Size24: '24px',
    /**
     * 32px
     */
    Size32: '32px',
    /**
     * 36px
     */
    Size36: '36px',
    /**
     * 40px
     */
    Size40: '40px',
    /**
     * 48px
     */
    Size48: '48px',
    /**
     * 56px
     */
    Size56: '56px',
    /**
     * 112px
     */
    Size112: '112px',
    /**
     * 224px
     */
    Size224: '224px',
    /**
     * 448px
     */
    Size448: '448px',
    /**
     * 0px
     */
    Space0: '0px',
    /**
     * 1px
     */
    Space1: '1px',
    /**
     * 2px
     */
    Space2: '2px',
    /**
     * 4px
     */
    Space4: '4px',
    /**
     * 6px
     */
    Space6: '6px',
    /**
     * 8px
     */
    Space8: '8px',
    /**
     * 10px
     */
    Space10: '10px',
    /**
     * 12px
     */
    Space12: '12px',
    /**
     * 16px
     */
    Space16: '16px',
    /**
     * 20px
     */
    Space20: '20px',
    /**
     * 24px
     */
    Space24: '24px',
    /**
     * 32px
     */
    Space32: '32px',
    /**
     * 40px
     */
    Space40: '40px',
    /**
     * 48px
     */
    Space48: '48px',
    /**
     * 56px
     */
    Space56: '56px',
    /**
     * 64px
     */
    Space64: '64px',
    /**
     * 72px
     */
    Space72: '72px',
    /**
     * 80px
     */
    Space80: '80px',
    /**
     * 88px
     */
    Space88: '88px',
    /**
     * 96px
     */
    Space96: '96px',
    /**
     * 144px
     */
    Space144: '144px',
    /**
     * 1100
     */
    ZIndexAppBar: 1100,
    /**
     * 1200
     */
    ZIndexDrawer: 1200,
    /**
     * 1350
     */
    ZIndexDropdown: 1350,
    /**
     * 1300
     */
    ZIndexModal: 1300,
    /**
     * 1000
     */
    ZIndexSidebar: 1000,
    /**
     * 1400
     */
    ZIndexSnackbar: 1400,
    /**
     * 1500
     */
    ZIndexTooltip: 1500,
};
//# sourceMappingURL=dimensions.variables.js.map